import { render, staticRenderFns } from "./AdsMWE.vue?vue&type=template&id=4cf9ed86&"
import script from "./AdsMWE.vue?vue&type=script&lang=js&"
export * from "./AdsMWE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports